export enum LocalStorageKeys {
  TENANT_ACCESS_ID = 'tenant_access_id',
  ACCESS_CODE = 'access_code',
}
